import { CustomerSpecificationTypeEntity } from '../dave-data-module/entities/customerSpecificationType.entity';

export const canCustomerHaveDoctors = (customerSpecificationType: CustomerSpecificationTypeEntity) => {
    return customerSpecificationType?.Name.toLocaleLowerCase() === 'px' || customerSpecificationType?.Name.toLocaleLowerCase() === 'kh';
}
